import { Box, Grid, Typography } from "@mui/material";
import { Item } from "../../styles/common";
import React, { useCallback } from "react";
import { useQuery } from "@apollo/client";
import { Filter, UserFilters } from "../users/UserFilters";
import { Table } from "../../common/table/Table";
import { BusinessRecommendationActivityFilter, BusinessRecommendationActivityFilterData } from "./BusinessRecommendationActivityFilter";
import { GET_BUSINESS_RECOMMENDATION_ACTIVITIES } from "./businessRecommendationActivity.queries";
import { config } from "../../config";

const perPage = config.rowsPerPage;

export const BusinessRecommendationActivity: React.FC<any> = (): JSX.Element => {
  let variables = React.useRef<any>({
    "pagination": {
      "skip": 0,
      "take": perPage
    },
    "activityfilter": {
      "filters": [
        {
          "field": "createdAt",
          "operator": ">=",
          "value": new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        }
      ],
      "operator": "AND"
    }
  });

  const { data, loading, refetch } = useQuery(GET_BUSINESS_RECOMMENDATION_ACTIVITIES, { variables: variables.current });

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(perPage);

  React.useEffect(() => {
    variables.current = {
      ...variables.current,
      pagination: {
        take: rowsPerPage,
        skip: page * rowsPerPage,
      },
    };
    refetch(variables.current);
  }, [page, rowsPerPage, refetch]);

  const onFilter = useCallback((filter: Filter) => {
    variables.current = {
      ...variables.current,
      filter: {
        fieldFilter: {
          filters: filter.filters,
          operator: filter.operator,
        },
        hasReferred: filter.usersThatHaveReferred,
        hasBeenReferred: filter.usersThatHaveBeenReferred,
        hasRecommendedABusiness: filter.usersThatHaveRecommended,
        hasRecommendedSameBusiness: filter.usersThatHaveRecommendedSameBusiness,
        visitedPage: filter.visitedPage,
        hasSharedReferralLink: filter.hasSharedReferralLink,
        referredByUser: filter.referredByUser,
      },
    };
    refetch(variables.current);
  }, [refetch]);

  const onActivityFilter = useCallback((filter: BusinessRecommendationActivityFilterData) => {
    variables.current = {
      ...variables.current,
      activityfilter: {
        filters: filter.filters,
        operator: filter.operator,
      },
    };
    refetch(variables.current);
  }, [refetch]);

  if (loading || !data?.getBusinessRecommendationActivities) return <h4>Loading...</h4>;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography sx={{ m: 2 }} variant="h4">User Activity</Typography>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1.5 }}>User filter</Typography>
            <UserFilters onFilter={onFilter} />
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 1.5 }}>Business recommendation activity filter</Typography>
            <BusinessRecommendationActivityFilter onFilter={onActivityFilter} />
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <Table
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              loading={loading}
              columns={[
                { label: 'First Name', key: 'firstName' },
                { label: 'Last Name', key: 'lastName' },
                { label: 'Username', key: 'username' },
                { label: 'Region City', key: 'regionCity' },
                { label: 'Region State', key: 'regionState' },
                { label: 'Region Country', key: 'regionCountry' },
              ]}
              rows={data.getBusinessRecommendationActivities.businessRecommendationActivities}
              total={data.getBusinessRecommendationActivities.total}
            />
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
};